(() => {
  const VENDOR_TO_BRAND_MAP = {
    'ASICS': 'Asics',
    'TEVA': 'Teva',
    'GABOR': 'Gabor',
    'ROCKPORT': 'Rockport',
    'DR. MARTENS': 'Dr. Martens',
    'UGG': 'UGG',
    'BIRKENSTOCK': 'Birkenstock',
    'VIONIC': 'Vionic',
    'CLARKS': 'Clarks',
    'CLAE': 'Clae',
    'COLE HAAN': 'Cole Haan',
    'FIT FLOP': 'Fit Flop',
    'TONI MONDAVI': 'Tony Mondavi',
    'REEF': 'Reef',
    'DANSKO': 'Dansko',
    'ARCHE': 'Arche',
    'PREMIATA': 'Premiata',
    'CAMPER': 'Camper',
    'ECCO': 'Ecco',
    'THIERRY RABOTIN': 'Thierry Rabotin'
  };

  const TAG_TO_GENDER_MAP = {
    'גברים': 'men',
    'נשים': 'women',
    'ילדים': 'kids'
  };

  const DATA_ATTR = {
    sizeConvert: 'data-size-convert',
    vendor: 'data-vendor',
    gender: 'data-gender',
    usSize: 'data-us-size'
  };

  const METAOBJECT_FIELD_KEY = {
    brand: 'brand',
    gender: 'gender',
    size: 'size',
    newSize: 'new_size'
  };

  const DISPLAY_SIZE_TRAILING_ZERO = /\.0$/;

  const WINDOW_MAP_KEY = '__SIZE_CONVERSION_MAP__';

  let sizeMap = null;

  function buildSizeMapFromMetaobjectNodes(nodes) {
    const result = {};
    if (!nodes || !Array.isArray(nodes)) {
      return result;
    }

    for (let nodeIndex = 0; nodeIndex < nodes.length; nodeIndex++) {
      const metaobjectNode = nodes[nodeIndex];
      const fields = metaobjectNode.fields || [];
      let brand = '';
      let gender = '';
      let size = '';
      let newSize = '';

      for (let fieldIndex = 0; fieldIndex < fields.length; fieldIndex++) {
        const field = fields[fieldIndex];
        if (field.key === METAOBJECT_FIELD_KEY.brand) {
          brand = String(field.value || '').trim();
        } else if (field.key === METAOBJECT_FIELD_KEY.gender) {
          gender = String(field.value || '').trim();
        } else if (field.key === METAOBJECT_FIELD_KEY.size) {
          size = String(field.value || '').trim();
        } else if (field.key === METAOBJECT_FIELD_KEY.newSize) {
          newSize = String(field.value || '').trim();
        }
      }

      if (brand && gender && size && newSize) {
        if (!result[brand]) {
          result[brand] = {};
        }
        if (!result[brand][gender]) {
          result[brand][gender] = {};
        }
        result[brand][gender][size] = newSize;
      }
    }

    return result;
  }

  function toDisplaySize(usSize, vendor, gender, conversionMap) {
    if (!conversionMap || !usSize) {
      return usSize || '';
    }
    const brandKey = (VENDOR_TO_BRAND_MAP[vendor] !== undefined) ? VENDOR_TO_BRAND_MAP[vendor] : vendor;
    return (conversionMap[brandKey]?.[gender]?.[usSize]) || usSize;
  }

  function getGenderFromProduct(product) {
    if (!product || !product.tags || !Array.isArray(product.tags)) {
      return '';
    }
    for (let tagIndex = 0; tagIndex < product.tags.length; tagIndex++) {
      const tag = product.tags[tagIndex];
      if (TAG_TO_GENDER_MAP[tag]) {
        return TAG_TO_GENDER_MAP[tag];
      }
    }
    return '';
  }

  function applyToPage() {
    if (!sizeMap) {
      return;
    }

    const selector = `[${DATA_ATTR.sizeConvert}][${DATA_ATTR.vendor}][${DATA_ATTR.usSize}]`;
    const elements = document.querySelectorAll(selector);

    for (let elementIndex = 0; elementIndex < elements.length; elementIndex++) {
      const element = elements[elementIndex];
      const vendor = element.getAttribute(DATA_ATTR.vendor) || '';
      const gender = element.getAttribute(DATA_ATTR.gender) || '';
      const usSizeFromAttr = element.getAttribute(DATA_ATTR.usSize) || '';
      const usSize = usSizeFromAttr.trim() || (element.textContent || '').trim();
      const displaySize = toDisplaySize(usSize, vendor, gender, sizeMap);
      const finalText = displaySize ? String(displaySize).replace(DISPLAY_SIZE_TRAILING_ZERO, '') : '';
      const valueToShow = finalText || usSize || element.textContent;
      if (valueToShow && valueToShow !== element.textContent) {
        element.textContent = valueToShow;
      }
    }
  }

  function initSizeConversion() {
    sizeMap = window[WINDOW_MAP_KEY] || null;
    applyToPage();
  }
  
  window.SizeConversion = {
    applyToPage: applyToPage,
    buildSizeMapFromMetaobjectNodes: buildSizeMapFromMetaobjectNodes,
    toDisplaySize: toDisplaySize,
    getGenderFromProduct: getGenderFromProduct
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSizeConversion);
  } else {
    initSizeConversion();
  }

})();
